import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { naturalCmp } from 'underscore.string';
import { Button, Glyphicon } from '@bingads-webui-react/primitive-unthemed';
import { CommandBarButton, PrimaryButton } from '@bingads-webui-react/fabric-control';
import { WithManagedFocuser } from '@bingads-webui-react/hoc-with-managed-focuser';
import { expressionTokenProp } from '@bingads-webui-react/hoc-with-expression-editor-controls';

export const SelectedMetric = WithManagedFocuser(class extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    expressionToken: expressionTokenProp.isRequired,
    focusableRef: PropTypes.func,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    isMetricSelected: PropTypes.bool,
    onKeyUp: PropTypes.func,
    onRemoveButtonClick: PropTypes.func,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    className: 'custom-column-selected-metric',
    isMetricSelected: false,
    focusableRef: _.noop,
    onKeyUp: _.noop,
    onRemoveButtonClick: _.noop,
    onSelect: _.noop,
  };

  render() {
    const {
      className,
      expressionToken,
      focusableRef,
      i18n,
      isMetricSelected,
      onKeyUp,
      onRemoveButtonClick,
      onSelect,
    } = this.props;
    const { title, segments } = expressionToken;
    let displayValue = title;

    if (segments && segments.categoryValue) {
      const segmentTitles = _.pluck(segments.selections, 'title');
      segmentTitles.sort(naturalCmp);
      displayValue += `: ${segmentTitles.join(',')}`;
    }

    const MetricButton = isMetricSelected ? PrimaryButton : CommandBarButton;

    return (
      <MetricButton
        className={classNames(className, isMetricSelected ? '' : 'btn-command')}
        onClick={onSelect}
        onKeyUp={onKeyUp}
        componentRef={focusableRef}
        role="button"
        tabIndex="0"
      >
        {displayValue}
        <Button
          aria-label={i18n.getString('CustomColumn_RemoveMetric')}
          btnStyle={isMetricSelected ? 'primary' : 'default'}
          onClick={onRemoveButtonClick}
        >
          <Glyphicon
            glyph="ba-Cancel"
          />
        </Button>
      </MetricButton>
    );
  }
});
